import Index from "./parts/index";
import Urls from "../../api/endpoints";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import Headings from "../../constants/headings";
import { NidInquiryStatusType, NoteType } from "../../enums/index";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getNidInquiryStatusText,
  getNidInquiryStatusClass,
} from "../../functions/index";
import { getAllNote, saveByAdmin, setUserNotesAutomatic } from "../../api/requestAxios/userInfo";
import UserInfo from ".";
import { ErrorToast, InfoToast } from "../../shared";
import constants from "../../constants/constants";
import CustomValuesHook from "../../Hooks/customValuesHook";
import GModal from '../../shared/gModal'

const Inside = (props) => {
  const navigate = useNavigate();
  const goToAuthPage = async () => {
    navigate(`/authentication`);
  };
  const [showSpinner, setShowSpinner] = useState(false);
  const [isEditMood, setIsEditMood] = useState(false);
  const [isEditSave, setIsEditSave] = useState(false);
  const [isValidEdit, setisValidEdit] = useState(true)
  const [componentChange, setComponentChange] = useState(false)
  const [disAbledBtn, setDisAbledBtn] = useState(false)
  const [updateMode, setUpdateMode] = useState("no-change")
  const [postalCodeVliad, setPostalCodeVliad] = useState(false)
  const [houseNumberVliad, setHouseNumberVliad] = useState(false)
  const [states, setStates] = CustomValuesHook({ displayModal: false })
  const [editInfo, setEditInfo] = useState({
    ResidencePostalCode: '',
    ProvinceName: '',
    CityName: '',
    ResidenceAddress: '',
    ProvinceId: '',
    CityId: '',
    Gender: ''
  })


  useEffect(() => {
    let obj = editInfo;
    obj.ResidencePostalCode = props.customer?.ResidencePostalCode
    obj.ProvinceName = props.customer?.Province
    obj.CityName = props.customer?.City
    obj.ResidenceAddress = props.customer?.ResidenceAddress
    obj.Gender = props.customer?.Gender
    obj.Street = props.customer?.Street
    obj.HouseNumber = props.customer?.HouseNumber

    setEditInfo(obj)

  }, [props.customer])


  const loginAsUser = (e, id) => {
    e.preventDefault();
    setShowSpinner(true);
    fetch(Urls.loginAsUser(id), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setShowSpinner(false);
        if (window.location.hostname.indexOf('dev') > -1 ||
          window.location.hostname.indexOf('localhost') > -1 ||
          window.location.hostname.indexOf('tebyan') > -1 ||
          window.location.hostname.indexOf('rahimi') > -1) {
          let path = data.split('?')[1]
          setStates({ path: path, displayModal: true })

          // path = "https://portaldev.daftareshoma.com/login.html?" + path
          setShowSpinner(false);
          // window.open(path);
        } else {
          window.open(data);

        }
      })
      .catch((error) => {
        setShowSpinner(false);
      });
  };

  const sendToPortal = (type) => {
    let url = `https://${type}.daftareshoma.com/login.html?${states.path}`
    setShowSpinner(false);
    window.open(url);
  }
  useEffect(() => {
    HandleUpdateMode()
  }, [editInfo])



  const HandleUpdateMode = () => {
    if (((editInfo?.CityName && editInfo?.CityName !== props?.customer?.City) ||
      (editInfo?.ProvinceName && editInfo?.ProvinceName !== props?.customer?.Province) ||
      editInfo?.ResidenceAddress !== props?.customer?.ResidenceAddress ||
      editInfo?.ResidencePostalCode !== props?.customer?.ResidencePostalCode ||
      editInfo?.Street !== props?.customer?.Street ||
      editInfo?.HouseNumber !== props?.customer?.HouseNumber
    ) &&
      editInfo?.Gender?.toString() === props?.customer?.Gender?.toString()) {
      setUpdateMode("address-changed-only")
    } else if (((editInfo?.CityName && editInfo?.CityName !== props?.customer?.City) ||
      (editInfo?.ProvinceName && editInfo?.ProvinceName !== props?.customer?.Province) ||
      editInfo?.ResidenceAddress !== props?.customer?.ResidenceAddress ||
      editInfo?.ResidencePostalCode !== props?.customer?.ResidencePostalCode ||
      editInfo?.Street !== props?.customer?.Street ||
      editInfo?.HouseNumber !== props?.customer?.HouseNumber
    ) &&
      editInfo?.Gender?.toString() !== props?.customer?.Gender?.toString()) {
      setUpdateMode("address-and-gender-changed")
    } else if (((!editInfo?.CityName || editInfo?.CityName === props?.customer?.City) &&
      (!editInfo?.ProvinceName || editInfo?.ProvinceName === props?.customer?.Province) &&
      editInfo?.ResidenceAddress === props?.customer?.ResidenceAddress &&
      editInfo?.ResidencePostalCode === props?.customer?.ResidencePostalCode &&
      editInfo?.Street === props?.customer?.Street &&
      editInfo?.HouseNumber === props?.customer?.HouseNumber
    ) &&
      editInfo?.Gender?.toString() !== props?.customer?.Gender?.toString()) {
      setUpdateMode("gender-changed-only")
    }
  }

  const EditAddressSaveFn = async () => {
    setShowSpinner(true);
    try {
      setShowSpinner(false);
      let obj = {
        CustomerId: props.customer.Id,
        ResidencePostalCode: editInfo.ResidencePostalCode,
        ResidenceAddress: editInfo.ResidenceAddress,
        CityId: editInfo.CityId,
        ProvinceId: editInfo.ProvinceId,
        Gender: editInfo.Gender,
        Street: editInfo.Street,
        Alley: editInfo.Alley,
        HouseNumber: editInfo.HouseNumber

      }
      const saveStatus = await saveByAdmin(obj)
      if (saveStatus.status) {
        setDisAbledBtn(false)
        setIsEditMood(false)
        props.isRefresh(true)
        if (updateMode === "address-changed-only") {
          InfoToast(constants.ChangeAddressSuccess)
        }
        else if (updateMode === "gender-changed-only") {
          InfoToast(constants.ChangeGanderSuccess)

        }
        else if (updateMode === "address-and-gender-changed") {
          InfoToast(constants.ChangeAddressAndGenderSuccess)

        }
        // saveNotFun();

      }
      else {
        setDisAbledBtn(false)
        setIsEditMood(false)

        if (updateMode === "address-changed-only") {
          InfoToast(constants.ChangeAddressFailed)
        }
        else if (updateMode === "gender-changed-only") {
          InfoToast(constants.ChangeGanderFailed)

        }
        else if (updateMode === "address-and-gender-changed") {
          InfoToast(constants.ChangeAddressAndGenderFailed)

        }
      }
    }

    catch (error) {
      setShowSpinner(false);
      setDisAbledBtn(false)
      InfoToast(constants.ChangeAddressFailed)
    }
  }


  const EditAddressSaveValidateFn = () => {
    if (!editInfo.ResidenceAddress || !editInfo.Street || !editInfo.HouseNumber) {
      ErrorToast('پر کردن موارد مشخص شده الزامی است')

    }
    else {
      EditAddressSaveFn()

    }

  }


  const saveNotFun = async () => {
    try {
      let isFullNull;
      if (
        props.customer?.Province ||
        props.customer?.City ||
        props.customer?.ResidenceAddress ||
        props.customer?.ResidencePostalCode ||
        props.customer?.HouseNumber ||
        props.customer?.Street) {
        isFullNull = false
      }
      else {
        isFullNull = true
      }
      let note = ''
      switch (updateMode) {

        case "address-changed-only":
          note = `
            ${Headings.UserAddress} ${!isFullNull ? Headings.From : ' '}

            ${props.customer?.ResidencePostalCode ? Headings.PostalCode : ''} 
            ${props.customer?.ResidencePostalCode ? props.customer?.ResidencePostalCode + ',' : ''} 

            ${props.customer?.Province ? ' ' + props.customer?.Province + ',' : ''} 

            ${props.customer?.City ? ' ' + props.customer?.City + ',' : ''} 

            ${props.customer?.ResidenceAddress ? props.customer?.ResidenceAddress + ',' : ''} 

            ${props.customer?.Street ? props.customer?.Street + ',' : ''} 

            ${props.customer?.HouseNumber ? Headings.HouseNumber : ''} 
            ${props.customer?.HouseNumber ? props.customer?.HouseNumber + ',' : ''}      

            ${Headings.To} 

            ${editInfo?.ResidencePostalCode ? Headings.PostalCode : ''}: 
            ${editInfo?.ResidencePostalCode ? editInfo?.ResidencePostalCode : ''} 

            ${editInfo?.ProvinceName ? editInfo?.ProvinceName + ',' : ''} 

            ${editInfo?.CityName ? editInfo?.CityName : ''}  
        
            ${editInfo?.ResidenceAddress ? editInfo?.ResidenceAddress + ',' : ''} 

            ${editInfo?.Street ? editInfo?.Street + ',' : ''} 

            ${editInfo?.HouseNumber ? Headings.HouseNumber : ''} 
            ${editInfo?.HouseNumber ? editInfo?.HouseNumber + ',' : ''}        
                  
            ${Headings.Change}`

          const saveStatus = await setUserNotesAutomatic(props.customer.Id, note.toString(), "ChangeAddress");

          if (saveStatus.status) {
            getAllNoteFn()
          }
          break;
        case "address-and-gender-changed":
          note = `
          ${Headings.UserAddress} ${!isFullNull ? Headings.From : ' '}

          ${props.customer?.ResidencePostalCode ? Headings.PostalCode : ''} 
          ${props.customer?.ResidencePostalCode ? props.customer?.ResidencePostalCode + ',' : ''} 

          ${props.customer?.Province ? ' ' + props.customer?.Province + ',' : ''} 

          ${props.customer?.City ? ' ' + props.customer?.City + ',' : ''} 

          ${props.customer?.ResidenceAddress ? props.customer?.ResidenceAddress + ',' : ''} 

          ${props.customer?.Street ? props.customer?.Street + ',' : ''} 

          ${props.customer?.HouseNumber ? Headings.HouseNumber : ''} 
          ${props.customer?.HouseNumber ? props.customer?.HouseNumber + ',' : ''}      

          ${Headings.To} 

          ${editInfo?.ResidencePostalCode ? Headings.PostalCode : ''}: 
          ${editInfo?.ResidencePostalCode ? editInfo?.ResidencePostalCode : ''} 

          ${editInfo?.ProvinceName ? editInfo?.ProvinceName + ',' : ''} 

          ${editInfo?.CityName ? editInfo?.CityName : ''}  
      
          ${editInfo?.ResidenceAddress ? editInfo?.ResidenceAddress + ',' : ''} 

          ${editInfo?.Street ? editInfo?.Street + ',' : ''} 

          ${editInfo?.HouseNumber ? Headings.HouseNumber : ''} 
          ${editInfo?.HouseNumber ? editInfo?.HouseNumber + ',' : ''}        
                
          ${Headings.Change}`
          const saveStatus2 = await setUserNotesAutomatic(props.customer.Id, note.toString(), "ChangeAddress");
          note = `${Headings.Gender} ${Headings.From} ${props.customer.Gender.toString() === "1" ? "زن" : "مرد"} ${Headings.To}  ${editInfo.Gender.toString() === "1" ? "زن" : "مرد"}  ${Headings.Change} `
          const saveStatus3 = await setUserNotesAutomatic(props.customer.Id, note.toString(), "ChangeGender");

          if (saveStatus2.status && saveStatus3.status) {
            getAllNoteFn()
          }
          break;
        case "gender-changed-only":
          note = `${Headings.Gender} ${Headings.From} ${props.customer.Gender.toString() === "1" ? "زن" : "مرد"} ${Headings.To}  ${editInfo.Gender.toString() === "1" ? "زن" : "مرد"}  ${Headings.Change} `
          const saveStatus4 = await setUserNotesAutomatic(props.customer.Id, note.toString(), "ChangeGender");
          if (saveStatus4.status) {
            getAllNoteFn()
          }
          break;
        default:
          break;
      }



    }
    catch (error) {

    }
  }


  const getAllNoteFn = async () => {
    try {
      const allNote = await getAllNote(props.customer.Id)
      if (allNote.status) {
        setComponentChange(true)
      }

    }
    catch (error) {

    }
  }

  const editClick = (e) => {
    if (/\b(?!(\d)\1{3})[13-9]{4}[1346-9][0123-9]{5}\b/.test(props.customer.ResidencePostalCode)) {
      setPostalCodeVliad(true)
    }
    if (/^\d+$/.test(props.customer.HouseNumber)) {
      setHouseNumberVliad(true)
    }

    setIsEditMood(true)
    setComponentChange(true)
    setIsEditSave(false);
  }

  const save = () => {
    if (isValidEdit) {
      //call API  
      EditAddressSaveValidateFn();
      setDisAbledBtn(true)

    }
    else {
      ErrorToast('پر کردن موارد الزامی ضروری است')
    }
    setIsEditSave(true);
    setComponentChange(!componentChange)


  }
  const cancel = () => {
    let obj = editInfo;
    obj.ResidencePostalCode = props.customer?.ResidencePostalCode
    obj.Province = props.customer?.Province
    obj.City = props.customer?.City
    obj.ResidenceAddress = props.customer?.ResidenceAddress
    obj.Gender = props.customer?.Gender
    setEditInfo(obj)

    setIsEditMood(false)
    setIsEditSave(false);
    setComponentChange(false)
  }


  return (

    <>
      <div className="top-margin"></div>
      <div className="user-info-container">
        <div className="user-info">
          <h1>
            {Headings.UserInfoTitle}
            {props.customer &&
              (props.customer.NidInquiryStatus ===
                NidInquiryStatusType.ReadyForInquiry() ||
                props.customer.NidInquiryStatus ===
                NidInquiryStatusType.InProgress() ? (
                <span
                  onClick={() => {
                    goToAuthPage();
                  }}
                  className={`cursor-pointer make-link ${getNidInquiryStatusClass(
                    props.customer.NidInquiryStatus
                  )}`}
                >
                  <b>
                    {getNidInquiryStatusText(props.customer.NidInquiryStatus)}
                  </b>
                </span>
              ) : (
                <span
                  className={`${getNidInquiryStatusClass(
                    props.customer.NidInquiryStatus
                  )}`}
                >
                  <b>
                    {getNidInquiryStatusText(props.customer.NidInquiryStatus)}
                  </b>
                </span>
              ))}
          </h1>
          <div className="panel-head-action">
            {!showSpinner ? (
              <div>
                <Button
                  className="login-as-user-btn"
                  onClick={(e) => loginAsUser(e, props.customer.Id)}
                >
                  {Headings.LoginAsUser}
                </Button>

                {isEditMood ?
                  <Button
                    className="cancel-edit-user-btn"
                    onClick={cancel}
                  >
                    {Headings.cancleEditSave}
                  </Button> : ''
                }

                {(props?.customer?.NidInquiryStatus === 2 || props?.customer?.NidInquiryStatus === 3) && <Button
                  className="edit-user-btn"
                  onClick={!isEditMood ? editClick : save}
                >
                  {!isEditMood ? Headings.EditAddress : Headings.EditAddressSave}
                </Button>
                }



              </div>


            ) : (
              <Button className="login-as-user-btn">
                <FontAwesomeIcon icon={faSpinner} spin />
              </Button>
            )}
          </div>
          <div className="divider"></div>
          <Index
            key={componentChange}
            customer={props.customer}
            token={props.token}
            userId={props.userId}
            isEditMood={isEditMood}
            setEditInfo={setEditInfo}
            editInfo={editInfo}
            setisValidEdit={setisValidEdit}
            postalCodeVliad={postalCodeVliad}
            setPostalCodeVliad={setPostalCodeVliad}
            houseNumberVliad={houseNumberVliad}
            setHouseNumberVliad={setHouseNumberVliad}
          ></Index>
        </div>
      </div>
      <GModal
        show={states.displayModal}
        setShow={() => setStates({ displayModal: false })}
        title={() => <div>ارسال به پرتال</div>}
        description={''}
        component={() => <div>
          <ul>
            <li style={{ padding: '5px 20px', cursor: 'pointer', backgroundColor: '#eeee', marginTop: '5px', borderRadius: '5px' }} onClick={() => { sendToPortal('portaldev') }}>ارسال به Portaldev</li>
            <li style={{ padding: '5px 20px', cursor: 'pointer', backgroundColor: '#eeee', marginTop: '5px', borderRadius: '5px' }} onClick={() => { sendToPortal('tebyan') }}>ارسال به tebyan dev</li>
            <li style={{ padding: '5px 20px', cursor: 'pointer', backgroundColor: '#eeee', marginTop: '5px', borderRadius: '5px' }} onClick={() => { sendToPortal('rahimi') }}>ارسال به Rahimi dev</li>
          </ul>
        </div>}
        classNames={''}
        size={'lg'}
        confirmButtonText={''}
        cancelButtonText={'انصراف'}
        backdrop={false} />
    </>
  );
};
export default Inside;
